import { useState, useRef } from "react";

import { useNavigate } from "react-router-dom";
import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";

import CustomModal from "@components/CustomModal";
import ImageImportTool from "@components/ImageImportTool";

import { Input } from "@fragments";

export default function ConfigSessionModal({ modalRef }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const { loadCommunities } = useCommunity();

    const REF_config = useRef({});
    const REF_callback = useRef();

    const nav = useNavigate();

    modalRef.current = {
        open(preFill, callback) {
            REF_config.current = { ...preFill };
            REF_callback.current = callback;
            setOpen(true);
        },
    };

    async function handleSubmit() {
        try {
            setLoading(true);
            const payload = getPayload();
            const { data } = await api.post("section", payload);

            if (data.id) {
                await REF_callback.current(data);
                await loadCommunities()
                setOpen(false);
            }
        } catch (e) {
            console.log(e);
        }

        setLoading(false);

        function getPayload() {
            const {
                id,
                community,
                name,
                description,
                banner_base64,
                banner_wide_base64,
            } = REF_config.current;

            const data = {
                community: parseInt(community),
                name: name.trim(),
                description: description?.text?.trim(),
            };

            if (!!id) {
                data.id = parseInt(id);
            }
            if (!!banner_base64 && !banner_base64?.startsWith("http")) {
                data.banner_base64 = banner_base64;
            }
            if (!!banner_wide_base64 && !banner_wide_base64?.startsWith("http")) {
                data.banner_wide_base64 = banner_wide_base64;
            }

            return data;
        }
    }

    async function handleDelete() {
        try {
            const { data } = await api.delete("section?id=" + REF_config.current.id);
        } catch (e) {
            console.log(e);
        }

        nav(-1);

        loadCommunities();

        setOpen(false);
    }


    return (
        <CustomModal
            maxWidth={450}
            bottomButtonSumbitText="Salvar sessão"
            bottomButtonCancelText="Cancelar"
            loading={loading}
            handleDelete={REF_config.current?.id && handleDelete}
            deletionTitle="Você realmente deseja apagar esta sessão permanentemente?"
            title={REF_config.current?.id ? "Editar sessão" : "Criar nova sessão"}
            handleSubmit={handleSubmit}
            open={open}
            handleClose={() => setOpen(false)}
            bodyComponent={
                open ? (
                    <div className="px-4 py-1">
                        <div className="banner-add mt-2">
                            <span>Banner para computador (16:4)</span>

                            <ImageImportTool
                                aspectRatio={16 / 4}
                                size={80}
                                imageMaxWidth={1700}
                                src={
                                    REF_config.current.banner_wide_base64 ||
                                    REF_config.current.banner?.wide
                                }
                                onCrop={(imageBase64) => {
                                    REF_config.current.banner_wide_base64 = imageBase64;
                                }}
                                title="Redimensionar banner do curso"
                            />
                        </div>
                        <div className="banner-add mt-2">
                            <span>Banner para celular (4:3)</span>

                            <ImageImportTool
                                aspectRatio={4 / 3}
                                size={120}
                                imageMaxWidth={1600}
                                src={
                                    REF_config.current.banner_base64 || REF_config.current.banner?.condensed
                                }
                                onCrop={(imageBase64) => {
                                    REF_config.current.banner_base64 = imageBase64;
                                }}
                                title="Redimensionar banner do curso"
                            />
                        </div>
                        <Input.Text
                            className="mt-4"
                            autoFocus={true}
                            placeholder="Nome do curso"
                            value={REF_config.current.name}
                            onInput={(v) => {
                                REF_config.current.name = v;
                            }}
                            label="Insira o nome do curso"
                            size={50}
                        />
                        <Input.Text
                            className="mt-2"
                            multiline
                            placeholder="Descrição (opcional)"
                            value={REF_config.current.description?.text}
                            onInput={(v) => {
                                REF_config.current.description = { ...REF_config.current.description, text: v };
                            }}
                            label="Adicione uma descrição resumida"
                            size={250}
                        />
                    </div>
                ) : null
            }
        />
    );
}
